export const UPDATE_SUBMITNOTICE_DETAILS ='UPDATE_SUBMITNOTICE_DETAILS';
export const UPDATE_IS_NAME_ERROR ='UPDATE_IS_NAME_ERROR';
export const UPDATE_IS_QTY_ERROR ='UPDATE_IS_QTY_ERROR';
export const UPDATE_IS_AGE_ERROR ='UPDATE_IS_AGE_ERROR';
export const UPDATE_IS_DESCRIPTION_ERROR ='UPDATE_IS_DESCRIPTION_ERROR';
export const UPDATE_IS_ITEMTYPE_ERROR ='UPDATE_IS_ITEMTYPE_ERROR';
export const UPDATE_IS_ACTION_ERROR ='UPDATE_IS_ACTION_ERROR';
export const UPDATE_IS_DETAILS_ERROR ='UPDATE_IS_DETAILS_ERROR';
export const UPDATE_ITEM_CONDITION_ERROR ='UPDATE_ITEM_CONDITION_ERROR';
export const UPDATE_IS_VALUE_ERROR ='UPDATE_IS_VALUE_ERROR';
export const UPDATE_COUNT ='UPDATE_COUNT';
export const UPDATE_NOTICE_ITEM_LIST ='UPDATE_NOTICE_ITEM_LIST';
export const UPDATE_SUBMITNOTICESTEP2_VIEWMODEL ='UPDATE_SUBMITNOTICESTEP2_VIEWMODEL';
export const UPDATE_IS_AMOUNTSOUGHT_ERROR ='UPDATE_IS_AMOUNTSOUGHT_ERROR';
export const UPDATE_IS_SEEK_COMPENSATION ='UPDATE_IS_SEEK_COMPENSATION';
export const UPDATE_NOTICENUMBER ='UPDATE_NOTICENUMBER';
export function updateSubmitNoticeDetails(data){
    return{
        type:UPDATE_SUBMITNOTICE_DETAILS,
        data:data
    }
}
export function updateIsNameError(data){
    return{
        type:UPDATE_IS_NAME_ERROR,
        data:data
    }
}
export function updateIsQtyError(data){
    return{
        type:UPDATE_IS_QTY_ERROR,
        data:data
    }
}
export function updateIsAgeError(data){
    return{
        type:UPDATE_IS_AGE_ERROR,
        data:data
    }
}
export function updateIsDescriptionError(data){
    return{
        type:UPDATE_IS_DESCRIPTION_ERROR,
        data:data
    }
}
export function updateIsItemTypeError(data){
    return{
        type:UPDATE_IS_ITEMTYPE_ERROR,
        data:data
    }
}
export function updateIsActionError(data){
    return{
        type:UPDATE_IS_ACTION_ERROR,
        data:data
    }
}
export function updateIsDetailsError(data){
    return{
        type:UPDATE_IS_DETAILS_ERROR,
        data:data
    }
}
export function updateItemConditionError(data){
    return{
        type:UPDATE_ITEM_CONDITION_ERROR,
        data:data
    }
}
export function updateIsValueError(data){
    return{
        type:UPDATE_IS_VALUE_ERROR,
        data:data
    }
}
export function updateCount(data){
    return{
        type:UPDATE_COUNT,
        data:data
    }
}
export function updateNoticeItemList(data){
    return{
        type:UPDATE_NOTICE_ITEM_LIST,
        data:data
    }
}
export function UpdateSubmitNoticeStep2ViewModel(data){
    return{
        type:UPDATE_SUBMITNOTICESTEP2_VIEWMODEL,
        data:data
    }
}
export function updateIsAmountSoughtError(data){
    return{
        type:UPDATE_IS_AMOUNTSOUGHT_ERROR,
        data:data
    }
}
export function updateIsSeekCompensation(data){
    return{
        type:UPDATE_IS_SEEK_COMPENSATION,
        data:data
    }
}
export function updateNoticeNumber(data){
    return{
        type:UPDATE_NOTICENUMBER,
        data:data
    }
}